/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherMoonIcon20Light = forwardRef('WeatherMoonIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.732 2.568c.153.224.19.54.031.817a5.75 5.75 0 0 0 7.851 7.852.768.768 0 0 1 .818.031c.23.158.389.46.298.8A8 8 0 1 1 7.933 2.27c.34-.09.641.067.799.298Zm-1.109.846a7 7 0 1 0 8.963 8.963 6.75 6.75 0 0 1-8.963-8.963Z" })));
});
